<template>
  <a-config-provider :locale="ruRU">
    <a-layout style="min-height:100vh">
      <a-layout-header class="app-header">
        <a-button
          v-if="auth.isLogged"
          type="text"
          @click="collapsed = !collapsed"
        >
          <MenuOutlined class="app-header-menu-icon" />
        </a-button>

        <div class="app-header-title">Туесок</div>

        <div class="app-header-spacer"></div>

        <template v-if="auth.isLogged">
          <div class="app-header-user">{{ headerIdentity }}</div>
          <a-button type="primary" danger @click="logout">Выйти</a-button>
        </template>
      </a-layout-header>

      <a-layout>
        <a-layout-sider
          v-if="auth.isLogged && !isMobile"
          theme="dark"
          width="220"
          collapsible
          v-model:collapsed="collapsed"
        >
          <SideMenu :selectedKey="selectedKey" @go="go" />
        </a-layout-sider>

        <a-drawer
          v-if="auth.isLogged && isMobile"
          theme="dark"
          placement="left"
          :open="collapsed"
          @close="collapsed = false"
          width="220"
        >
          <SideMenu :selectedKey="selectedKey" @go="go" />
        </a-drawer>

        <a-layout-content style="padding:16px">
          <router-view />
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-config-provider>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { message } from 'ant-design-vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from './stores/auth'
import { MenuOutlined } from '@ant-design/icons-vue'
import ruRU from 'ant-design-vue/es/locale/ru_RU'
import SideMenu from './components/SideMenu.vue'
import { getMe } from './api/profile'

const auth = useAuthStore()
const router = useRouter()
const route = useRoute()

const collapsed = ref(false)
const isMobile = ref(window.innerWidth < 768)

function handleResize() {
  isMobile.value = window.innerWidth < 768
}

onMounted(() => {
  window.addEventListener('resize', handleResize)
  hydrateCurrentUser()
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
})

const selectedKey = computed(() => route.path)
const headerIdentity = computed(() => auth.user?.login || auth.user?.phone || 'Пользователь')

function go(path) {
  router.push(path)
  if (isMobile.value) collapsed.value = false
}

function logout() {
  auth.logout()
  router.push('/login')
}

async function hydrateCurrentUser() {
  if (!auth.isLogged) return

  try {
    const res = await getMe()
    if (res?.data?.data) auth.setUser(res.data.data)
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Не удалось загрузить профиль')
  }
}
</script>

<style scoped>
.app-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.app-header-menu-icon {
  color: #fff;
  font-size: 18px;
}

.app-header-title {
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  white-space: nowrap;
}

.app-header-spacer {
  flex: 1;
}

.app-header-user {
  color: rgba(255, 255, 255, 0.92);
  font-size: 14px;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 767px) {
  .app-header {
    gap: 8px;
  }

  .app-header-title {
    font-size: 15px;
  }

  .app-header-user {
    max-width: 110px;
    font-size: 12px;
  }
}

@media print {
  :deep(.ant-layout-header),
  :deep(.ant-layout-sider),
  :deep(.ant-drawer) {
    display: none !important;
  }

  :deep(.ant-layout),
  :deep(.ant-layout-content) {
    background: #fff !important;
  }

  :deep(.ant-layout-content) {
    padding: 0 !important;
    margin: 0 !important;
  }
}
</style>
